<kui-modal #details class="details-modal" [title]="data.title" [actions]="modalActions" (onClose)="detachModal()">
    @if (data.type === "alert" || data.type === "event") {
        <key-event-details
            class="d-flex flex-column flex-container flex-1 position-relative overflow-auto"
            [showActions]="false"
            [isMobile]="true"
            [event]="data.selectedItem"
            [eventFeedService]="data.feedService"
        ></key-event-details>
    }
    @if (data.type === "trip") {
        <key-trip-preview
            class="d-flex flex-column flex-container flex-1 position-relative overflow-auto"
            [showActions]="false"
            [isMobile]="true"
            [dateStart]="data.selectedItem['dateStart']"
            [assetId]="data.id"
        ></key-trip-preview>
    }
</kui-modal>
